<template>
  <div id="App">
    <TopBar></TopBar>
    <Header></Header>

    <router-view />
    <Footer></Footer>
    <TinyFooter></TinyFooter>
  </div>
</template>



<script>
import TopBar from "@/components/TopBar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer";
import TinyFooter from "@/components/TinyFooter";

export default {
  name: "App",
  components: {
    TopBar,
    Header,
    Footer,
    TinyFooter,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
